import {auth} from '../../../Components/MiddlePopup/SignInModal/firebaseConfig.ts';
import {GoogleAuthProvider, signInWithCredential} from "firebase/auth";
import {URL_BASE} from "../../../Globals.ts";
import {isMobileApp} from "../../misc/envNameUtils.ts";

export async function exchangeCodeForToken(code: any, tokenType: string) {
    try {
        const url = `${URL_BASE}/api/exchangeCodeForToken`;

        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ code: code, tokenType: tokenType })
        });

        if (response.ok) {
            return await response.json();
        } else {
            console.error(`Failed to fetch token: ${response.statusText}`);
        }
    } catch (error) {
        console.error(`Error fetching token: ${error}`);
    }
}

export const createUserInFirebaseIfNotExist = async (idToken: string) => {
    try {
        const credential = GoogleAuthProvider.credential(idToken);
        const userCredential = await signInWithCredential(auth, credential);
        return userCredential.user;
    } catch (error) {
        console.error('Error signing in or creating user:', error);
        throw error;
    }
};

export const getGoogleProfileInfo = async (token: string, tokenType: string, environment: string, vscode: any) => {
    try {
        const tokens = await exchangeCodeForToken(token, tokenType);

        if (tokens.refresh_token) {
            if (environment.includes("jetbrains")) {
                window.jetbrainsPostMessage(JSON.stringify({
                    functionName: "giveRefreshToken",
                    data: [{ refreshToken: tokens.refresh_token }]
                }));
            } else if (isMobileApp(environment)) {
                window.ReactNativeWebView.postMessage(JSON.stringify({
                    functionName: "giveRefreshToken",
                    data: [{ refreshToken: tokens.refresh_token }]
                }));
            } else {
                vscode.postMessage({
                    functionName: "giveRefreshToken",
                    data: [{ refreshToken: tokens.refresh_token }]
                });
            }
        }

        if (tokens.access_token) {
            return await createUserInFirebaseIfNotExist(tokens.id_token);
        }
    } catch (error) {
        console.error('Failed to exchange token:', error);
    }
}